import { createSelector } from 'reselect';
import get from 'lodash/get';
import { initialState } from './reducer';
import { createSelectFieldOptions, getPeriodFromDates } from '../../utils/common';
import { i18n } from '../../src/i18n';
import { getKeyOfTranslateBySortSlug } from './utils';

const selectRentalsDomain = state => state.Rentals || initialState;

const selectRentals = () =>
  createSelector(selectRentalsDomain, subState => {
    const rentalsData = get(subState, initialState.rentals.listName);
    const data = get(rentalsData, 'data')?.map(rental => {
      const period = getPeriodFromDates(rental.dateFrom, rental.dateTo);
      return { ...rental, period };
    });
    return { ...rentalsData, data };
  });

const selectStartAggregations = () =>
  createSelector(selectRentalsDomain, subState => get(subState, 'startAggregations'));

const selectOperas = () =>
  createSelector(selectRentalsDomain, subState => createSelectFieldOptions(get(subState, 'operas'), 'id', 'name'));
const selectOperasLoading = () => createSelector(selectRentalsDomain, subState => get(subState, 'operasLoading'));

const selectTeams = () =>
  createSelector(selectRentalsDomain, subState => createSelectFieldOptions(get(subState, 'teams'), 'id', 'name'));
const selectTeamsLoading = () => createSelector(selectRentalsDomain, subState => get(subState, 'teamsLoading'));

const selectCompanies = () =>
  createSelector(selectRentalsDomain, subState => createSelectFieldOptions(get(subState, 'companies'), 'id', 'name'));
const selectCompaniesLoading = () => createSelector(selectRentalsDomain, subState => get(subState, 'companiesLoading'));

const selectSorts = () =>
  createSelector(selectRentalsDomain, subState =>
    get(subState, 'sorts').map(({ slug }) => ({
      value: slug,
      label: i18n.t(getKeyOfTranslateBySortSlug(slug)),
    })),
  );

export {
  selectOperas,
  selectOperasLoading,
  selectTeams,
  selectTeamsLoading,
  selectCompanies,
  selectCompaniesLoading,
  selectSorts,
  selectStartAggregations,
  selectRentals,
};
